import {
  Box,
  Button,
  TextField,
  Popover,
  PopoverProps,
  TextFieldProps,
  Typography,
} from "@/common/styles/style";
import { styles } from "./style";
import { ReactNode } from "react";

interface InputPopoverProps extends PopoverProps {
  anchorEl: HTMLElement | null;
  editValue?: string | number;
  setEditValue?: (value: string | number) => void;
  handleEditSubmit?: (event?: any) => void;
  buttonLabel?: string;
  textProps?: TextFieldProps;
  onClose?: () => void;
  children?: ReactNode;
}

export default function InputPopover({
  anchorEl,
  editValue,
  setEditValue,
  handleEditSubmit,
  buttonLabel,
  textProps,
  onClose,
  children,
  ...props
}: InputPopoverProps) {
  return (
    <Popover anchorEl={anchorEl} onClose={onClose} {...props}>
      <form onSubmit={handleEditSubmit}>
        {children ? (
          children
        ) : (
          <Box sx={styles.box}>
            <TextField
              fullWidth
              {...textProps}
              value={editValue}
              onChange={(e) => setEditValue && setEditValue(e.target.value)}
            />
            <Button
              variant="contained"
              fullWidth
              sx={styles.button}
              type="submit"
            >
              <Typography variant="button">{buttonLabel}</Typography>
            </Button>
          </Box>
        )}
      </form>
    </Popover>
  );
}
